export enum CHART_TYPE {
    bar,
    linear,
}
